import { NativeBackButton } from '@/components/ux/NativeBackButton';
import Logo from '../../components/Logo';

export default function CommunityGuidelines() {
  return (
    <div className="min-h-screen bg-white dark:bg-neutral-900 py-16 px-4 text-type-900 dark:text-white">
      <div className="max-w-4xl mx-auto">
        <NativeBackButton className="mb-4" />
        <div className="mb-8">
          <Logo link="/" />
        </div>
        
        <h1 className="text-4xl font-bold mb-8">🌈 Community Guidelines</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-lg leading-relaxed mb-6">
            Outclose exists to create meaningful connections, safe spaces, and vibrant experiences for LGBTQ+ communities and allies. These guidelines outline how we keep our community respectful, inclusive, and thriving. By participating, you agree to uphold these values.
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">1. Respect & Kindness</h2>
            <ul className="space-y-2">
              <li>Treat all members with dignity, compassion, and empathy.</li>
              <li>Disagreement is natural, but harassment, personal attacks, or hostile behavior are never acceptable.</li>
              <li>Listen actively and honor the perspectives of others, especially across differences of identity and experience.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">2. Inclusivity & Belonging</h2>
            <ul className="space-y-2">
              <li>Outclose is for everyone across the LGBTQ+ spectrum and allies who align with our values.</li>
              <li>Celebrate diversity of race, gender, sexuality, ability, body type, culture, and background.</li>
              <li>Use inclusive language and respect chosen names and pronouns.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">3. Safety & Boundaries</h2>
            <ul className="space-y-2">
              <li>Consent is non-negotiable—physical, digital, and emotional.</li>
              <li>No unwanted advances, sexual harassment, or pressuring behavior.</li>
              <li>Protect personal boundaries: respect privacy both online and offline.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">4. Authenticity & Integrity</h2>
            <ul className="space-y-2">
              <li>Be genuine—whether attending events, hosting, or connecting digitally.</li>
              <li>No impersonation, misleading information, or fraudulent activity.</li>
              <li>Hosts and participants must honor commitments (e.g., RSVP honesty, reliability).</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">5. Anti-Exploitation & Ethics</h2>
            <ul className="space-y-2">
              <li>Outclose is a community, not a marketplace for exploitation.</li>
              <li>Prohibited: hate speech, discriminatory behavior, predatory practices, or monetizing at the expense of community trust.</li>
              <li>We encourage collaboration and mutual uplift, not extraction.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">6. Privacy & Confidentiality</h2>
            <ul className="space-y-2">
              <li>Respect confidentiality of personal stories, identities, and experiences.</li>
              <li>Do not share community content outside of Outclose spaces without permission.</li>
              <li>Follow platform security rules—no doxxing, stalking, or unauthorized data use.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">7. Accountability & Growth</h2>
            <ul className="space-y-2">
              <li>If harm occurs, acknowledge it and take steps toward repair.</li>
              <li>Outclose reserves the right to warn, suspend, or remove members who violate guidelines.</li>
              <li>We encourage feedback to continually strengthen our culture of care.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">8. Shared Responsibility</h2>
            <ul className="space-y-2">
              <li>Hosts set the tone: uphold guidelines in all gatherings.</li>
              <li>Members co-create community: call each other in, not just out.</li>
              <li>Every action should strengthen connection, safety, and joy.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">9. Events &amp; Connecting (Kikis)</h2>
            <ul className="space-y-2">
              <li>Use Kikis for genuine connection—keep posts welcoming and respectful.</li>
              <li>When meeting someone in person, put safety first: meet in public, and look out for one another.</li>
              <li>RSVP honestly and show up when you commit; don't use events or Kikis to spam, recruit, or sell.</li>
              <li>Treat fellow attendees and hosts with the same respect online and offline.</li>
            </ul>
          </section>

          <p className="text-lg leading-relaxed mt-8 border-t pt-8">
            Outclose thrives when we hold each other with respect, curiosity, and care. These guidelines are not about rigid rules—they are about cultivating trust, belonging, and transformation together.
          </p>
        </div>
      </div>
    </div>
  );
}

